import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './type';

const reducers = {
  setSelectedIntegration: (state: IRootState, action: PayloadAction<IRootState['selectedIntegration']>) => ({
    ...state,
    selectedIntegration: action.payload,
  }),
  setGustoData: (state: IRootState, action: PayloadAction<IRootState['gustoData']>) => ({
    ...state,
    gustoData: action.payload,
  }),
  setActiveStep: (state: IRootState, action: PayloadAction<IRootState['activeStep']>) => ({
    ...state,
    activeStep: action.payload,
  }),
  setGustoReportData: (state: IRootState, action: PayloadAction<IRootState['gustoReportData']>) => ({
    ...state,
    gustoReportData: action.payload,
  }),
  setMgmReportData: (state: IRootState, action: PayloadAction<IRootState['mgmReportData']>) => ({
    ...state,
    mgmReportData: action.payload,
  }),
};

export {
  reducers,
};
